import { isLast } from "@punks/core"
import classNames from "classnames"
import React from "react"
import classes from "./CustomPane.module.css"

export interface PaneItem {
  className?: string
  content: React.ReactNode
  style?: React.CSSProperties
}

export interface CustomPaneProps {
  contents: PaneItem[]
  style?: React.CSSProperties
  className?: string
}

const CustomPane = ({ contents, style, className }: CustomPaneProps) => {
  return (
    <div className={classNames(classes.root, className)} style={style}>
      {contents.map((x, index) => (
        <div
          key={index}
          className={`${classes.item} ${
            !isLast(index, contents) ? classes.itemNotLast : classes.itemLast
          } ${x.className ?? ""}`}
          style={x.style}
        >
          {x.content}
        </div>
      ))}
    </div>
  )
}

export default CustomPane
